module.exports = __webpack_public_path__ + "static/media/tick-circle-icon.9441fcbd.svg";